module.exports = __webpack_public_path__ + "site/img/icon_2f_seat.3224e59c.svg";